<div
	class="number-counter"
	[class.number-counter--lg]="size === 'lg'"
	[class.number-counter--disabled]="disabled"
>
	<button
		*ngIf="!disabled"
		type="button"
		class="number-counter-btn"
		[disabled]="decrementDisabled"
		(click)="decrement()"
		aria-label="Decrease"
	>
		<span
			class="material-symbols-outlined"
			[class.material-symbols-outlined--size-24]="size === 'md'"
			[class.material-symbols-outlined--size-32]="size === 'lg'"
			aria-hidden="true"
		>
			remove
		</span>
	</button>
	<input
		type="text"
		inputmode="numeric"
		pattern="[0-9]*"
		autocomplete="off"
		class="number-counter-value"
		[value]="displayValue"
		[readonly]="disabled"
		[attr.aria-readonly]="disabled ? true : null"
		(focus)="onFocus($event)"
		(input)="onInput($event)"
		(blur)="onBlur()"
		(keydown)="onKeydown($event)"
		[attr.aria-label]="ariaLabel"
	/>
	<button
		*ngIf="!disabled"
		type="button"
		class="number-counter-btn"
		[disabled]="incrementDisabled"
		(click)="increment()"
		aria-label="Increase"
	>
		<span
			class="material-symbols-outlined"
			[class.material-symbols-outlined--size-24]="size === 'md'"
			[class.material-symbols-outlined--size-32]="size === 'lg'"
			aria-hidden="true"
		>
			add
		</span>
	</button>
</div>
